import { useAppSelector } from "app/redux-store-interactions";
import { selectPicker } from "features/render";
import { Picker } from "features/render/types";
import { hasMouseSupport } from "utils/misc";

import { useMobileCoordinate } from "./useMobileCoordinate";
import { useMobileDimension } from "./useMobileDimension";
import { useMobileLaser } from "./useMobileLaser";
import { useMobilePointLine } from "./useMobilePointLine";

function PointLineIntegration() {
    useMobilePointLine();
    return null;
}

function DimensionIntegration() {
    useMobileDimension();
    return null;
}

function LaserIntegration() {
    useMobileLaser();
    return null;
}

function CoordinateIntegration() {
    useMobileCoordinate();
    return null;
}

export function MobileMeasureIntegration() {
    const picker = useAppSelector(selectPicker);

    if (hasMouseSupport()) {
        return null;
    }

    switch (picker) {
        case Picker.PointLine:
            return <PointLineIntegration />;
        case Picker.Dimension:
            return <DimensionIntegration />;
        case Picker.OutlineLaser:
            return <LaserIntegration />;
        case Picker.Coordinates:
            return <CoordinateIntegration />;
        default:
            return null;
    }
}
